import { Box, Divider, Tab, Tabs, Tooltip } from "@mui/material";
import React, { useEffect, useRef } from "react";

import LockMilestone from "../styles/svg/LockUnlock.svg";
import { truncateText } from "../utils";
import { useCustomSearchParams } from "../hooks/useCustomSearchParams";
import { useSetMultipleParams } from "../hooks/useSetMultipleParams";

function TabsController({ value, tabsOptions, children, leftChild, tabsRef }) {
  const [NoMilestone, setMilestone] = useCustomSearchParams("noMilestone");
  const [setMultipleParams] = useSetMultipleParams();
  const tabRefs = useRef({});

  useEffect(() => {
    if (tabRefs.current[value]) {
      tabRefs.current[value].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center", // Ensures horizontal scrolling
      });
    }
  }, [value]);
  return (
    <>
      <Tabs
        value={value}
        ref={tabsRef}
        textColor="primary"
        indicatorColor="primary"
        aria-label="controlled tabs with specific values"
        TabIndicatorProps={{
          className: "tab-indicator-style",
        }}
        className="tabs-controller-style">
        {leftChild}
        <Tab
          value={""}
          label={"All"}
          onClick={() => {
            setMultipleParams([
              {
                name: "noMilestone",
                value: false,
              },
              {
                name: "milestone",
                value: "",
              },
              {
                name: "GantChart",
                value: "false",
              },
            ]);
          }}
          className={
            value === "" && NoMilestone !== "true"
              ? "custom-tab-active-no-milestone"
              : NoMilestone === "true"
              ? "custom-tab-milestone"
              : "before_milestone custom-tab-milestone"
          }
        />

        <Tab
          value={""}
          label={"Not Set"}
          onClick={() => {
            setMultipleParams([
              {
                name: "noMilestone",
                value: true,
              },
              {
                name: "milestone",
                value: "",
              },
              {
                name: "GantChart",
                value: "false",
              },
            ]);
          }}
          className={
            value === "" && NoMilestone === "true"
              ? "custom-tab-active-no-milestone"
              : value === tabsOptions[0]?.epic_id
              ? "custom-tab-milestone"
              : "custom-tab-milestone before_milestone"
          }
        />
        {tabsOptions?.map((openMilestone, idx) => {
          const isNextTabActive = tabsOptions[idx + 1]?.epic_id === value;          
          return (
            <Tab
              key={`milestoneTab-${openMilestone?.epic_id}`}
              value={openMilestone?.epic_id}
              label={truncateText(openMilestone?.epic_name, 30)}
              icon={openMilestone?.is_locked && <img src={LockMilestone} />}
              ref={(el) => (tabRefs.current[openMilestone?.epic_id] = el)}
              onClick={() => {
                setMultipleParams([
                  {
                    name: "noMilestone",
                    value: false,
                  },
                  {
                    name: "milestone",
                    value: openMilestone?.epic_id,
                  },
                ]);
              }}
              iconPosition="start"
              className={
                value === openMilestone?.epic_id
                  ? "custom-tab-active-milestone"
                  : value === tabsOptions[idx + 1]?.epic_id
                  ? "custom-tab-milestone"
                  : "custom-tab-milestone before_milestone"
              }
            />
          );
        })}
        {children}
      </Tabs>
    </>
  );
}

export default TabsController;
